/* AdvisoryDetailComponent.js */

"use strict";

//const BaseAdvisoryViewColumnComponent = require("../BaseAdvisoryViewColumnComponent");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./AdvisoryDetailRenderer");
const _ = require("lodash");

class AdvisoryDetailComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._logsRendered = false;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._advisoryColumn = undefined;
            this._logsRendered = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.advisoryColumn)) {
            this.setAdvisoryColumn(newVal.advisoryColumn);
        }
    }

    getValue() {
        return {
            advisoryColumn: this.getAdvisoryColumn()
        };
    }

    setAdvisoryColumn(newVal) {
        this._advisoryColumn = newVal;
        this.emit("AdvisoryColumn", newVal);
        return this;
    }

    getAdvisoryColumn() {
        return this._value;
    }

    _getToolTipContent(empty) {
        if (empty) {
            return `<span class="arrow"><i></i></span><div class="main-container p-b-0"><p>Loading...</p></div>`;
        }
        this._logsRendered = true;
        return `<span class="arrow"><i></i></span><div class="main-container p-b-0">${this._getAdvisoryID()} ${this._getSummary()} ${this._getCves()} ${this._getBugIDs()}</div>`;
    }

    _getAdvisoryID() {
        return `<b class='section-header top-item'>Advisory ID : </b> <div class='section-content'>${this.getAdvisoryColumn().getAdvisoryId()}</div>`;
    }

    _getSummary() {
        return `<b class='section-header'>Summary : </b> <div class='section-content'>${this.getAdvisoryColumn().getSummary()}</div>`;
    }

    _getCves() {
        const title = `<b class='section-header'>CVEs: </b>`;
        return `${title} <div class='section-content'> ${
            this.getAdvisoryColumn().getCves().length > 0 ? this.getAdvisoryColumn().getCves().join(" ") : "No CVEs available"
        }</div>`;
    }

    _getBugIDs() {
        const title = `<b class='section-header'>Bug IDs: </b>`;
        return `${title} <div class='section-content p-b-0'> ${
            this.getAdvisoryColumn().getBugIDs().length > 0 ? this.getAdvisoryColumn().getBugIDs().join(" ") : "No Bug IDs available"
        }</div>`;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AdvisoryDetailComponent;
